import { Grid, Pagination, Skeleton } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import FaqCard from "./faqcard";
import { FormattedMessage } from "react-intl";
import { PapiroConsole } from "src/utils/papiroConsole";
import Api from "src/services/api";
import { DialogFile } from "src/components/dialog-file";
import DialogGeneral from "src/components/dialog-general";

const LlmDocumentFaqList = (props) => {
    const { intl, onShowNotification, onLoading, loading, refresh } = props

    const [faqLlmDocuments, setFaqLlmDocuments] = useState([])
    const [pageLlmDocument, setPageLlmDocument] = useState(1)
    const [totalLlmDocument, setTotalLlmDocument] = useState(0)
    const [totalPagesLlmDocument, setTotalPagesLlmDocument] = useState(0)
    const [pageStartLlmDocument, setPageStartLlmDocument] = useState(0)
    const [pageEndLlmDocument, setPageEndLlmDocument] = useState(0)
    const [open, setOpen] = useState(false)
    const [openFaqDelete, setOpenFaqDelete] = useState(false)
    const [faqSelected, setFaqSelected] = useState(null)
    const [faqDelete, setFaqDelete] = useState(null)

    useEffect(() => {
        getFaq()
    }, [refresh])

    const getFaq = async (page = 1) => {
        let url = `/faq/paginate?page=${page}`

        // let newFilter = localStorage.getItem('newFilter');
        // let newSearch = localStorage.getItem('newSearch');
        // if (newFilter != '' && newSearch != '') {
        //     url += `&search=${newSearch}&field=${newFilter}`;
        //     this.setState({ dataFilter: true });
        // }
        url += `&llmdocument=true`
        onLoading(true)
        await Api.get(url)
            .then((response) => {
                if (response) {
                    setTotalLlmDocument(response.data?.count)
                    setPagination(response.data?.count, page)
                    setFaqLlmDocuments(response.data.data)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const setPagination = (count, page) => {
        setTotalPagesLlmDocument(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStartLlmDocument(start)
        setPageEndLlmDocument(Math.min(start + 9, count))
    }

    const onChangePaginate = (event, value) => {
        setPageLlmDocument(value)
        getFaq(value)
    }

    const onOpenFaq = (file) => {
        PapiroConsole.log("open faq")
    }

    const onDelete = async () => {
        let url = `/llmdocumentfaq/${faqDelete.id}`
        onLoading(true)
        await Api.delete(url)
            .then(async (response) => {
                if (response) {
                    await getFaq(pageLlmDocument)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            }).finally(() => {
                setOpenFaqDelete(false)
            })
        onLoading(false)
    }

    return (
        <>
            {loading ? (
                <Grid container spacing={1.25}>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Skeleton variant="rounded" height={160} />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Grid container paddingTop={2} spacing={1.25}>
                    {faqLlmDocuments.map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <FaqCard
                                item={item}
                                onClick={_ => {
                                    setFaqSelected(item)
                                    // setOpen(true)
                                }}
                                onDelete={_ => {
                                    setFaqDelete(item)
                                    setOpenFaqDelete(true)
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}

            <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                    <Pagination count={totalPagesLlmDocument} page={pageLlmDocument} onChange={onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {pageStartLlmDocument} {<FormattedMessage id="to" />} {pageEndLlmDocument} {<FormattedMessage id="of" />} {totalLlmDocument} {<FormattedMessage id="register" />}
                </Grid>
            </Grid>

            <DialogFile
                file={faqSelected}
                title={faqSelected?.id + " - " + faqSelected?.question}
                intl={intl}
                open={open}
                onClose={() => setOpen(false)}
                onOpenFile={onOpenFaq}
                onDelete={onDelete}
                openMessage={intl.formatMessage({ id: "go.to.faq" })}
            />
            
            <DialogGeneral
                intl={intl}
                dialogTitle={faqDelete?.id + " - " + faqDelete?.question}
                dialogSubTitle="Você realmente deseja remover este faq da llm?"
                open={openFaqDelete}
                openOrCloseModalFunction={setOpenFaqDelete}
                handleConfirmation={onDelete}
            />
        </>
    )
}

export default LlmDocumentFaqList